<template>
    <Teleport to="body">
        <div
            class="fixed inset-0 z-[2000] flex items-center justify-center p-4"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
            @click.self="onBackdropClick"
        >
            <div
                class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                aria-hidden="true"
                @click="onBackdropClick"
            ></div>

            <div
                class="relative z-10 flex w-full max-w-[calc(100vw-2rem)] max-h-[calc(100dvh-2rem)] flex-col overflow-hidden transform rounded-lg text-left shadow-xl transition-all"
                :class="computedInnerClass"
            >
                <div class="min-h-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain">
                    <slot/>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>

export default {
    name: 'Modal',
    emits: ['modalClose'],
    props: {
        closeOnClickOutside: {
            default: true,
            required: false,
            type: Boolean,
        },
        width: {
            default: 'w-full sm:max-w-lg',
            required: false,
        },
        bgColour: {
            type: String,
            default: 'bg-white',
            required: false
        },
        innerClass: {
            type: String,
            default: '',
            required: false
        },
    },
    computed: {
        computedInnerClass() {
            let innerClass = ''

            if (this.width) {
                innerClass += this.width + ' '
            }

            if (this.bgColour) {
                innerClass += this.bgColour + ' '
            }

            return innerClass + this.innerClass
        }
    },
    mounted() {
        document.body.classList.add('overflow-hidden')
    },
    unmounted() {
        document.body.classList.remove('overflow-hidden')
    },
    methods: {
        onBackdropClick() {
            if (this.closeOnClickOutside) {
                this.$emit('modalClose')
            }
        }
    }
}

</script>
